import axios from '@liepin/cnpm-js-axios-fe';
import qs from 'qs';

const ajax = axios.create({
  timeout: 30000,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  transformRequest: [
    data => {
      return qs.stringify(data)
    }
  ],
});
ajax.interceptors.response.use(
  ({ data }) => {
    return data;
  }
)
export default ajax;
